import type { ErrorSeverity } from '@cbhq/error-vitals-web';
import { setBaseUrl as setAccountManagementBaseUrl } from '@cbhq/identity-api-hooks/account-management';
import { createErrorReporter, setErrorHandler } from '@cbhq/instant-api-hooks-core';

import { logError } from './logging';

const errorReporter = createErrorReporter(
  ({ error, severity, errorInfo, metadata, context }, errorHash) => {
    const parsedSeverity: ErrorSeverity = severity === 'info' ? 'debug' : severity ?? 'error';

    logError(error, {
      severity: parsedSeverity,
      errorHash,
      context: 'iah_error_reporter',
      errorContext: context,
      ...metadata,
      ...errorInfo,
    });
  },
);

export function initInstantApiHooks(): void {
  setAccountManagementBaseUrl('');
  setErrorHandler(errorReporter);
}
